import router          from '@/router';
import store           from '@/store';
import { VDataTable }  from 'vuetify/labs/VDataTable'
import TestDataService from './services/TestDataService';
import UserDataService from './services/UserDataService';
import { sanitizeHtml } from '@/assets/js/common/sanitize';

import {
    Chart as ChartJS,
    ArcElement, Tooltip, Legend, Title,
    BarElement, CategoryScale, LinearScale,
    RadialLinearScale, PointElement, LineElement,
} from 'chart.js'
import { Pie, Bar, Radar, Doughnut } from 'vue-chartjs'

ChartJS.register(
    ArcElement, Tooltip, Legend, Title,
    BarElement, CategoryScale, LinearScale,
    RadialLinearScale, PointElement, LineElement,
)

export default {

    name: 'Nota',
    components: { Pie, Bar, Radar, Doughnut, VDataTable },

    data: () => ({

        chartData: [],
        chartDataGrupo: [],
        chartDataBarStacked:  { labels: [], datasets: [] },
        chartDataHistogram:   { labels: [], datasets: [] },
        chartDataRadarAI:     { labels: [], datasets: [] },
        chartDataRadarAE:     { labels: [], datasets: [] },
        selectedStudentGauge: null,
        selectedStudentGaugeAI: null,
        selectedStudentGaugeAE: null,
        selectedStudentBarAI: null,
        selectedStudentBarAE: null,

        charOptions: {
            responsive: true,
            maintainAspectRatio: false,
        },
        charOptionsBarStacked: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: 'top' } },
            scales: {
                x: { stacked: true },
                y: { stacked: true, beginAtZero: true },
            },
        },
        charOptionsHistogram: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: false } },
            scales: {
                y: { beginAtZero: true, ticks: { stepSize: 1 } },
            },
        },
        charOptionsRadar: {
            responsive: true,
            maintainAspectRatio: true,
            scales: {
                r: { min: 0, max: 100, ticks: { stepSize: 25 }, pointLabels: { font: { size: 13 } } },
            },
        },
        charOptionsGauge: {
            responsive: true,
            maintainAspectRatio: false,
            circumference: 180,
            rotation: -90,
            cutout: '70%',
            plugins: {
                legend: { position: 'bottom' },
                tooltip: { enabled: true },
            },
        },
        charOptionsBarPerQ: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { position: 'top' } },
            scales: { y: { beginAtZero: true } },
        },

        datetime: '',
        dialogDelete: false,
        headersStudentsGrades: [
            { title: 'Aluno (a)', key: 'nome_usuario', align: 'start' },
        ],
        headersDashboardStudents: [
            { title: 'Aluno (a)', key: 'nome_usuario', align: 'start' },
            { title: 'AI', key: 'totalPI', align: 'center' },
            { title: 'AE', key: 'totalPG', align: 'center' },
            { title: 'Final', key: 'totalF', align: 'center' },
        ],
        headersTests: [
            { title: 'Nome',     key: 'nome',              align: 'start',  width: '28%' },
            { title: 'Disciplina', key: 'disciplina',      align: 'start',  width: '18%' },
            { title: 'Professor', key: 'usuario_nome',     align: 'start',  width: '18%' },
            { title: 'Questoes', key: 'perguntas.length',  align: 'center', width: '10%' },
            { title: 'Status',   key: 'get_status_display',align: 'center', width: '16%' },
            { title: 'Criacao',  key: 'datetime',          align: 'center', width: '10%' },
            { title: 'Acoes',    key: 'id',                align: 'center', sortable: false, width: '10%' },
        ],
        idTest: null,
        json_fields: {},
        listStudentsGrades: [],
        listDashboardStudents: [],
        listTestReport: [],
        listTests: [],
        loadingTurmas: true,
        loadingStudentsGrades: true,
        loadingTests: true,
        notaEquipe: null,
        notaIndividual: null,
        notaMaxima: null,
        nQuestoes: null,
        optGabarito: false,
        perguntas: [],
        sbColor: '',
        sbMessage: '',
        snackbar: false,
        sortByData: [{ key: 'datetime', order: 'desc' }],
        sortByName: [{ key: 'nome_usuario', order: 'asc' }],
        selectedDashboardStudentId: null,
        selectedTurmaCodigo: '',
        provaId: null,
        provaNome: '',
        provaSenha: '',
        pt: '',
        statusNomeProva: '',
        statusProva: '',
        turmas: [],
    }),

    mounted() {
        this.handlePageChange(this.currentParamsPage);
    },

    computed: {
        currentParamsPage() {
            return this.$route.params;
        },
    },

    watch: {
        alert(new_val){
            if(new_val){
              setTimeout(()=>{this.alert=false}, 5000)
            }
        },
        currentParamsPage(newVal, _oldVal) {
            this.handlePageChange(newVal);
        },
    },

    methods: {

        sanitizeHtml,

        convertHeadersToJSON(headers) {
            const json_fields = {};
            for (const header of headers) {
                json_fields[header.title] = header.key;
            }
            return json_fields;
        },
        normalizeTurmas(turmas) {
            return (Array.isArray(turmas) ? turmas : [])
                .map((turma) => ({
                    id: turma.id || turma.codigo,
                    codigo: String(turma.codigo || turma.nome || '').toUpperCase(),
                    nome: turma.nome || `Turma ${turma.codigo}`,
                    label: String(turma.codigo || turma.nome || '').toUpperCase(),
                }))
                .filter((turma) => turma.codigo)
                .sort((a, b) => a.codigo.localeCompare(b.codigo, 'pt-BR', { sensitivity: 'base' }));
        },

        async loadTurmas() {
            this.loadingTurmas = true;
            try {
                const response = await UserDataService.listTurmas();
                this.turmas = this.normalizeTurmas(response.data || []);
                if (!this.turmas.some((turma) => turma.codigo === this.selectedTurmaCodigo)) {
                    this.selectedTurmaCodigo = this.turmas[0]?.codigo || '';
                }
            } catch (error) {
                console.log(error);
                this.turmas = [];
                this.selectedTurmaCodigo = '';
            } finally {
                this.loadingTurmas = false;
            }
        },

        async handleTurmaChange() {
            await this.getTests();
        },

        getGradeGaugeColor(score, maxScore) {
            const value = Number(score);
            const max = Number(maxScore);
            if (!Number.isFinite(value) || !Number.isFinite(max) || max <= 0) {
                return '#B00020';
            }

            const percent = (value / max) * 100;
            if (percent < 30) return '#B00020';
            if (percent < 60) return '#FBC02D';
            return '#2E7D32';
        },

        buildGradeGaugeData(score, maxScore, obtainedLabel = 'Nota') {
            const value = Number(score);
            const max = Number(maxScore);
            const safeValue = Number.isFinite(value) ? value : 0;
            const safeMax = Number.isFinite(max) && max > 0 ? max : 0;
            const filled = safeMax > 0 ? Math.min(Math.max(safeValue, 0), safeMax) : 0;
            const remaining = Math.max(0, safeMax - filled);
            const percent = safeMax > 0 ? (safeValue / safeMax) * 100 : 0;
            const displayPercent = Math.max(0, Math.min(percent, 100));

            return {
                labels: [
                    `${obtainedLabel} (${displayPercent.toFixed(1)}%)`,
                    `Restante (${Math.max(0, 100 - displayPercent).toFixed(1)}%)`,
                ],
                datasets: [{
                    data: [filled, remaining],
                    backgroundColor: [this.getGradeGaugeColor(safeValue, safeMax), '#E5E7EB'],
                    borderWidth: 0,
                }],
            };
        },

        selectDashboardStudent(student) {
            this.selectedDashboardStudentId = student?.usuario || student;
            this.buildSelectedStudentDashboard();
        },

        buildSelectedStudentDashboard() {
            const student = this.listDashboardStudents.find(
                item => String(item.usuario) === String(this.selectedDashboardStudentId)
            ) || this.listDashboardStudents[0];

            if (!student) {
                this.selectedStudentGauge = null;
                this.selectedStudentGaugeAI = null;
                this.selectedStudentGaugeAE = null;
                this.selectedStudentBarAI = null;
                this.selectedStudentBarAE = null;
                return;
            }

            this.selectedDashboardStudentId = student.usuario;
            const notaFinal = parseFloat(student.totalF || 0);
            const piScore = parseFloat(student.totalPI || 0);
            const pgScore = parseFloat(student.totalPG || 0);
            const notaMax = parseFloat(this.notaMaxima || 0);
            const piMax = parseFloat(this.notaIndividual || 0);
            const pgMax = parseFloat(this.notaEquipe || 0);
            const labels = Array.from({ length: this.nQuestoes || 0 }, (_, i) => `Q${i + 1}`);

            this.selectedStudentGauge = this.buildGradeGaugeData(notaFinal, notaMax, 'Nota Final');
            this.selectedStudentGaugeAI = this.buildGradeGaugeData(piScore, piMax, 'AI Obtida');
            this.selectedStudentGaugeAE = this.buildGradeGaugeData(pgScore, pgMax, 'AE Obtida');
            this.selectedStudentBarAI = {
                labels,
                datasets: [
                    { label: 'Nota (AI)', backgroundColor: '#3C6E8F', data: student.piPerQuestion || [] },
                    { label: 'Máximo', backgroundColor: 'rgba(60,110,143,0.2)', data: labels.map(() => parseFloat((piMax / (this.nQuestoes || 1)).toFixed(2))) },
                ],
            };
            this.selectedStudentBarAE = {
                labels,
                datasets: [
                    { label: 'Nota (AE)', backgroundColor: '#B88645', data: student.pgPerQuestion || [] },
                    { label: 'Máximo', backgroundColor: 'rgba(184,134,69,0.2)', data: labels.map(() => parseFloat((pgMax / (this.nQuestoes || 1)).toFixed(2))) },
                ],
            };
        },

        closeDelete() {
            this.dialogDelete = false;
        },

        deleteTestAsk(id) {
            this.dialogDelete = true;
            this.idTest = id;
        },

        async deleteTestConfirm(id) {
            await TestDataService.delete(id).then(() => {
                this.sbColor   = 'success';
                this.sbMessage = 'A atividade avaliativa foi excluida!';
                this.snackbar  = true;
            }).catch(() => {
                this.sbColor   = 'error';
                this.sbMessage = 'Erro ao excluir a atividade avaliativa!';
                this.snackbar  = true;
            });
            await this.getTests();
            this.closeDelete();
        },

        formatDate(dateString) {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo' }).format(date);
        },

        formatDateTime(dateString) {
            const date = new Date(dateString);
            return new Intl.DateTimeFormat('pt-BR', {
                year: 'numeric', month: '2-digit', day: '2-digit',
                hour: '2-digit', minute: '2-digit', second: '2-digit',
                timezone: 'America/Sao_Paulo',
            }).format(date);
        },

        getStudentsGrades(id) {

            TestDataService.studentsTest(id).then(response => {

                const prova      = response.data.prova;
                const npi        = response.data.notas_prova_individual;
                const grupos     = response.data.grupos;
                const npg        = response.data.notas_prova_grupo;
                const numResults = npi.length;

                if (store.state.userSex === 'm' || store.state.userSex === 'ni') { this.pt = 'Professor:'; }
                else if (store.state.userSex === 'f') { this.pt = 'Professora: '; }

                this.provaNome      = prova.nome;
                this.datetime       = this.formatDateTime(prova.datetime);
                this.statusProva    = prova.get_status_display;
                if (prova.opt_gabarito === true) {
                    this.optGabarito = 'O questionario com gabarito esta sendo exibido ao aluno';
                }
                this.notaMaxima     = prova.nota_maxima;
                this.notaIndividual = (prova.nota_individual * prova.nota_maxima) / 100;
                this.notaEquipe     = (prova.nota_equipe * prova.nota_maxima) / 100;

                if (numResults > 0) {

                    this.nQuestoes        = prova.perguntas.length;
                    const numAlts         = prova.perguntas[0].answers.length;
                    const perguntas       = prova.perguntas;
                    const valueQuestionPI = this.notaIndividual / this.nQuestoes;
                    const valueQuestionPG = this.notaEquipe / this.nQuestoes;

                    let alunoID, grupoID;

                    if (this.headersStudentsGrades.length > 1) {
                        this.headersStudentsGrades.splice(1);
                    }

                    for (let i = 0; i < this.nQuestoes; i++) {
                        this.headersStudentsGrades.push({ title: `PI Q${i+1}`, key: `nota_${i+1}`, align: 'center', sortable: true });
                    }
                    this.headersStudentsGrades.push({ title: 'PI Total', key: 'totalPI', align: 'center', sortable: true });

                    for (let i = 0; i < this.nQuestoes; i++) {
                        this.headersStudentsGrades.push({ title: `PG Q${i+1}`, key: `notag_${i+1}`, align: 'center', sortable: true });
                    }
                    this.headersStudentsGrades.push({ title: 'PG Total',    key: 'totalPG', align: 'center', sortable: true });
                    this.headersStudentsGrades.push({ title: 'Total Final', key: 'totalF',  align: 'center', sortable: true });

                    for (let i = 0; i < numResults; i++) {

                        let nota;
                        let total  = 0;
                        let totalg = 0;

                        alunoID = npi[i].usuario;

                        for (let a = 0; a < grupos.length; a++) {
                            for (let b = 0; b < grupos[a].id_usuarios.length; b++) {
                                if (grupos[a].id_usuarios[b] === alunoID) {
                                    grupoID = grupos[a].id;
                                }
                            }
                        }

                        for (let j = 0; j < this.nQuestoes; j++) {
                            const altTrue = parseInt(perguntas[j].altTrue);
                            for (let l = 0; l < numAlts; l++) {
                                const altPos = l + 1;
                                if (npi[i].respostas[j]?.answers[l].answer) {
                                    const answer = parseInt(npi[i].respostas[j].answers[l].answer);
                                    if (altPos === altTrue) {
                                        nota                    = ((answer / numAlts) * 100 * valueQuestionPI) / 100;
                                        npi[i]['nota_' + (j+1)] = nota.toFixed(2);
                                        total                  += nota;
                                    }
                                }
                            }

                            for (let c = 0; c < npg.length; c++) {
                                let notag = 0;
                                if (grupoID === npg[c].grupo) {
                                    const answer = npg[c].respostas['question' + (j+1)];
                                    let foundCorrect = false;
                                    if (answer) {
                                        for (let d = 0; d < answer.length; d++) {
                                            if (parseInt(answer[d]) === altTrue) {
                                                foundCorrect = true;
                                                if (d === 0) {
                                                    notag = valueQuestionPG;
                                                } else if (d > 0 && d < (numAlts - 1)) {
                                                    notag = (100 / Math.pow(2, d) * valueQuestionPG) / 100;
                                                } else if (d === (numAlts - 1)) {
                                                    notag = 0;
                                                }
                                                npi[i]['notag_' + (j+1)] = notag.toFixed(2);
                                                totalg += notag;
                                                break;
                                            }
                                        }
                                        if (!foundCorrect && Array.isArray(answer) && answer.length >= numAlts) {
                                            npi[i]['notag_' + (j+1)] = '0.00';
                                        }
                                    }
                                    npi[i].totalPG = totalg.toFixed(2);
                                }
                            }
                        }
                        npi[i].totalPI = total.toFixed(2);
                        npi[i].totalF  = (parseFloat(npi[i].totalPI) + parseFloat(npi[i].totalPG)).toFixed(2);
                    }
                    this.json_fields           = this.convertHeadersToJSON(this.headersStudentsGrades);
                    this.listStudentsGrades    = npi;
                    this.loadingStudentsGrades = false;
                } else {
                    this.loadingStudentsGrades = false;
                }

            }).catch(error => {
                console.log(error);
            });
        },

        getTestReport(id) {

            TestDataService.studentsTest(id).then(response => {

                const prova      = response.data.prova;
                const npi        = response.data.notas_prova_individual;
                const grupos     = response.data.grupos;
                const npg        = response.data.notas_prova_grupo;
                const numResults = npi.length;

                if (store.state.userSex === 'm' || store.state.userSex === 'ni') { this.pt = 'Professor:'; }
                else if (store.state.userSex === 'f') { this.pt = 'Professora: '; }

                this.provaNome      = prova.nome;
                this.datetime       = this.formatDateTime(prova.datetime);
                this.statusProva    = prova.get_status_display;
                this.notaMaxima     = prova.nota_maxima;
                this.notaIndividual = (prova.nota_individual * prova.nota_maxima) / 100;
                this.notaEquipe     = (prova.nota_equipe * prova.nota_maxima) / 100;

                if (numResults > 0) {

                    this.nQuestoes        = prova.perguntas.length;
                    const numAlts         = prova.perguntas[0].answers.length;
                    const perguntas       = prova.perguntas;
                    const valueQuestionPI = this.notaIndividual / this.nQuestoes;
                    const valueQuestionPG = this.notaEquipe / this.nQuestoes;

                    let alunoID, grupoID;

                    // — Counting loop (populates listTestReport for pie charts) —
                    for (let i = 0; i < numResults; i++) {

                        alunoID = npi[i].usuario;
                        grupoID = null;

                        for (let a = 0; a < grupos.length; a++) {
                            for (let b = 0; b < grupos[a].id_usuarios.length; b++) {
                                if (grupos[a].id_usuarios[b] === alunoID) {
                                    grupoID = grupos[a].id;
                                }
                            }
                        }

                        for (let j = 0; j < this.nQuestoes; j++) {

                            if (i === 0) {
                                this.listTestReport.push({
                                    question: perguntas[j].question,
                                    totalNR: 0, totalA: 0, totalAP: 0, totalNE: 0, totalE: 0,
                                    totalGrupoNR: 0, totalGrupoA: 0, totalGrupoAP: 0, totalGrupoNE: 0, totalGrupoE: 0,
                                });
                            }

                            const altTrue = parseInt(perguntas[j].altTrue);

                            for (let l = 0; l < numAlts; l++) {
                                const altPos = l + 1;
                                if (npi[i].respostas[j]?.answers[l].answer) {
                                    const answer = parseInt(npi[i].respostas[j].answers[l].answer);
                                    if (altPos === altTrue) {
                                        if (answer === numAlts) { this.listTestReport[j].totalA  += 1; }
                                        else if (answer === 0)  { this.listTestReport[j].totalE  += 1; }
                                        else                    { this.listTestReport[j].totalAP += 1; }
                                    }
                                } else {
                                    this.listTestReport[j].totalNR += 1;
                                }
                            }

                            for (let c = 0; c < npg.length; c++) {
                                if (grupoID === npg[c].grupo) {
                                    const answer = npg[c].respostas['question' + (j+1)];
                                    let foundCorrect = false;
                                    if (answer) {
                                        for (let d = 0; d < answer.length; d++) {
                                            if (parseInt(answer[d]) === altTrue) {
                                                foundCorrect = true;
                                                if (d === 0)                    { this.listTestReport[j].totalGrupoA  += 1; }
                                                else if (d < numAlts - 1)       { this.listTestReport[j].totalGrupoAP += 1; }
                                                else if (d === numAlts - 1)     { this.listTestReport[j].totalGrupoE  += 1; }
                                                break;
                                            }
                                        }
                                        if (!foundCorrect && Array.isArray(answer) && answer.length >= numAlts) {
                                            this.listTestReport[j].totalGrupoE += 1;
                                        }
                                    } else {
                                        this.listTestReport[j].totalGrupoNR += 1;
                                    }
                                }
                            }
                        }
                    }

                    // — Score loop (computes per-student totals for bar / histogram charts) —
                    const studentScores = [];

                    for (let i = 0; i < numResults; i++) {

                        alunoID = npi[i].usuario;
                        grupoID = null;

                        for (let a = 0; a < grupos.length; a++) {
                            for (let b = 0; b < grupos[a].id_usuarios.length; b++) {
                                if (grupos[a].id_usuarios[b] === alunoID) {
                                    grupoID = grupos[a].id;
                                }
                            }
                        }

                        let totalPI = 0;
                        let totalPG = 0;
                        const piPerQuestion = [];
                        const pgPerQuestion = [];

                        for (let j = 0; j < this.nQuestoes; j++) {
                            const altTrue = parseInt(perguntas[j].altTrue);
                            let piQuestionScore = 0;
                            let pgQuestionScore = 0;

                            for (let l = 0; l < numAlts; l++) {
                                const altPos = l + 1;
                                if (npi[i].respostas[j]?.answers[l].answer) {
                                    const answer = parseInt(npi[i].respostas[j].answers[l].answer);
                                    if (altPos === altTrue) {
                                        piQuestionScore = ((answer / numAlts) * 100 * valueQuestionPI) / 100;
                                        totalPI += piQuestionScore;
                                    }
                                }
                            }

                            for (let c = 0; c < npg.length; c++) {
                                if (grupoID === npg[c].grupo) {
                                    const answer = npg[c].respostas['question' + (j+1)];
                                    if (answer) {
                                        for (let d = 0; d < answer.length; d++) {
                                            if (parseInt(answer[d]) === altTrue) {
                                                if (d === 0)              { pgQuestionScore = valueQuestionPG; }
                                                else if (d < numAlts - 1) { pgQuestionScore = (100 / Math.pow(2, d) * valueQuestionPG) / 100; }
                                                totalPG += pgQuestionScore;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                            piPerQuestion.push(parseFloat(piQuestionScore.toFixed(2)));
                            pgPerQuestion.push(parseFloat(pgQuestionScore.toFixed(2)));
                        }

                        studentScores.push({
                            usuario: npi[i].usuario,
                            nome:    npi[i].nome_usuario,
                            nome_usuario: npi[i].nome_usuario,
                            totalPI: parseFloat(totalPI.toFixed(2)),
                            totalPG: parseFloat(totalPG.toFixed(2)),
                            totalF:  parseFloat((totalPI + totalPG).toFixed(2)),
                            piPerQuestion,
                            pgPerQuestion,
                        });
                    }

                    studentScores.sort((a, b) => String(a.nome_usuario || '').localeCompare(
                        String(b.nome_usuario || ''),
                        'pt-BR',
                        { sensitivity: 'base' }
                    ));

                    this.listDashboardStudents = studentScores;
                    this.selectedDashboardStudentId = studentScores[0]?.usuario || null;
                    this.buildSelectedStudentDashboard();

                    // Gráfico 1 — Barras Empilhadas: AI + AE = Total por aluno
                    this.chartDataBarStacked = {
                        labels: studentScores.map(s => s.nome),
                        datasets: [
                            { label: 'Atividade Individual (AI)', backgroundColor: '#3C6E8F', data: studentScores.map(s => s.totalPI) },
                            { label: 'Atividade em Equipe (AE)',  backgroundColor: '#B88645', data: studentScores.map(s => s.totalPG) },
                        ],
                    };

                    // Gráfico 2 — Histograma: distribuição das notas finais
                    const numBins  = 5;
                    const binSize  = this.notaMaxima / numBins;
                    const bins     = Array(numBins).fill(0);
                    const binLabels = Array.from({ length: numBins }, (_, b) =>
                        `${(b * binSize).toFixed(1)} – ${((b + 1) * binSize).toFixed(1)}`
                    );
                    for (const s of studentScores) {
                        const bin = Math.min(Math.floor(s.totalF / binSize), numBins - 1);
                        bins[bin]++;
                    }
                    this.chartDataHistogram = {
                        labels: binLabels,
                        datasets: [{ label: 'Nº de Alunos', backgroundColor: '#3C6E8F', data: bins }],
                    };

                    // Gráfico 3 — Radar: % acertos por questão (turma)
                    const radarLabels = perguntas.map((_, i) => `Q${i + 1}`);
                    const acertosPI   = this.listTestReport.map(r => {
                        const tot = r.totalA + r.totalAP + r.totalE + r.totalNR;
                        return tot > 0 ? parseFloat(((r.totalA / tot) * 100).toFixed(1)) : 0;
                    });
                    const acertosPG = this.listTestReport.map(r => {
                        const tot = r.totalGrupoA + r.totalGrupoAP + r.totalGrupoE + r.totalGrupoNR;
                        return tot > 0 ? parseFloat(((r.totalGrupoA / tot) * 100).toFixed(1)) : 0;
                    });
                    this.chartDataRadarAI = {
                        labels: radarLabels,
                        datasets: [{
                            label: 'AI — Acertos (%)',
                            backgroundColor: 'rgba(60,110,143,0.2)', borderColor: '#3C6E8F', pointBackgroundColor: '#3C6E8F',
                            data: acertosPI,
                        }],
                    };
                    this.chartDataRadarAE = {
                        labels: radarLabels,
                        datasets: [{
                            label: 'AE — Acertos (%)',
                            backgroundColor: 'rgba(184,134,69,0.2)', borderColor: '#B88645', pointBackgroundColor: '#B88645',
                            data: acertosPG,
                        }],
                    };
                }

                // Pie charts existentes — um por questão
                for (let i = 0; i < this.nQuestoes; i++) {
                    this.chartData.push({
                        labels: ['Não Respondeu', 'Correto', 'Acertou Parcialmente', 'Errou'],
                        datasets: [{
                            backgroundColor: ['#CBD5E1', '#2E7D5B', '#B88645', '#B42318'],
                            data: [
                                this.listTestReport[i].totalNR,
                                this.listTestReport[i].totalA,
                                this.listTestReport[i].totalAP,
                                this.listTestReport[i].totalE,
                            ],
                        }],
                    });
                    this.chartDataGrupo.push({
                        labels: ['Não Respondeu', 'Correto', 'Acertou Parcialmente', 'Errou'],
                        datasets: [{
                            backgroundColor: ['#CBD5E1', '#2E7D5B', '#B88645', '#B42318'],
                            data: [
                                this.listTestReport[i].totalGrupoNR,
                                this.listTestReport[i].totalGrupoA,
                                this.listTestReport[i].totalGrupoAP,
                                this.listTestReport[i].totalGrupoE,
                            ],
                        }],
                    });
                }

            }).catch(error => {
                console.log(error);
            });
        },

        async getTests() {
            this.loadingTests = true;
            await TestDataService.list({
                turma_codigo: this.selectedTurmaCodigo,
            }).then(response => {
                this.listTests    = response.data;
                this.loadingTests = false;
            }).catch(error => {
                console.log(error);
            });
        },

        async handlePageChange(params) {

            clearInterval(this.interval);

            if (params.psPage === 'Listar') {
                if (!this.turmas.length) {
                    await this.loadTurmas();
                }
                this.getTests();
            } else if (params.psPage === 'Notas') {
                this.listStudentsGrades = [];
                this.getStudentsGrades(params.id);
            } else if (params.psPage === 'Estatisticas') {
                this.listTestReport = [];
                this.getTestReport(params.id);
            }
        },

        seeGrades(id) {
            router.push({ path: '/Provas/Notas/' + id });
        },

        seeReports(id) {
            router.push({ path: '/Provas/Estatisticas/' + id });
        },
    },
};
